import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { whiteRiverJunctionConfig } from "./data";

export default function WhiteRiverJunctionPage() {
  return <CityPageTemplate config={whiteRiverJunctionConfig} />;
}